<div class="container-fluid d-flex h-100 g-0">
  <div class="row g-0">
    <div class="col-12 col-lg-6 signup">
      <div class="d-flex align-items-center justify-content-center signup_logo">
        <img src="/assets/img/logos/logo_travelgate_blue.svg" alt="Logo Travelgate" />
      </div>
      <!-- User form -->
      @if (!userEmail) {
        <tgx-web-site-public-v3-sign-up-user-form
          (updateUserEmail)="updateUserEmail($event)"
        ></tgx-web-site-public-v3-sign-up-user-form>
      }
      <!--  Activate account  -->
      @if (userEmail) {
        <tgx-web-site-public-v3-sign-up-activate-account
          [userEmail]="userEmail"
        ></tgx-web-site-public-v3-sign-up-activate-account>
      }
    </div>
    <div class="d-none d-lg-block col-lg-6">
      <div class="bg-signup">
        <p class="xen-heading-1">Keep moving forward and empower your travel business.</p>
        <p class="bg-signup__subtitle">Your race starts now!</p>
        <img class="bg-signup__img-race" src="/assets/img/pages/signup/race.webp" alt="race image" />
      </div>
    </div>
  </div>
</div>
